import { render, staticRenderFns } from "./CommonLoad.vue?vue&type=template&id=ea27e3c6&scoped=true"
import script from "./CommonLoad.vue?vue&type=script&lang=ts"
export * from "./CommonLoad.vue?vue&type=script&lang=ts"
import style0 from "./CommonLoad.vue?vue&type=style&index=0&id=ea27e3c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea27e3c6",
  null
  
)

export default component.exports